import {
  TrackingStatus,
  TrackerOutputTranslationElementId,
} from './components/TrackerOutput/TrackerOutputModels';
import { FooterTranslationElementId } from './components/Footer/FooterModels';
import { TrackerSearchElementId } from './components/TrackerSearchBar/TrackerSearchBarModels';
import { NavbarTranslationElementId } from './components/Navbar/NavbarModels';


export enum TrackingStatusExtendedDescriptionId {
  prepared = 'shipment_prepared',
  delivered = 'shipment_delivered',
  exception = 'shipment_exception',
  in_transit = 'shipment_in_transit',
  out_for_delivery = 'shipment_out_for_delivery',
  received_by_carrier = 'shipment_received_by_carrier',
  not_found = 'shipment_not_found',
  cancelled = 'shipment_cancelled',
}

export interface TranslationMessage {
  [TrackerOutputTranslationElementId.card_tracking_number_header]: string;
  [TrackerOutputTranslationElementId.carrier_name]: string,
  [TrackerOutputTranslationElementId.deliver_to]: string;
  [TrackerOutputTranslationElementId.estimated_delivery]: string;
  [TrackingStatusExtendedDescriptionId.not_found]: string;

  // Homepage Track Body Elements
  [TrackerSearchElementId.track_button]: string;
  [TrackerSearchElementId.track_textfield_placeholder]: string;

  // Navbar Elements
  [NavbarTranslationElementId.header]: string;
  [NavbarTranslationElementId.menu]: string;
  [NavbarTranslationElementId.language]: string;

  // Footer Elements
  [FooterTranslationElementId.copyright_notice_message]: string;
  [FooterTranslationElementId.timezone_notice_message]: string;

  // Individual description of tracking status
  [TrackingStatusExtendedDescriptionId.delivered]: string;
  [TrackingStatusExtendedDescriptionId.exception]: string;
  [TrackingStatusExtendedDescriptionId.in_transit]: string;
  [TrackingStatusExtendedDescriptionId.out_for_delivery]: string;
  [TrackingStatusExtendedDescriptionId.prepared]: string;
  [TrackingStatusExtendedDescriptionId.received_by_carrier]: string;
  [TrackingStatusExtendedDescriptionId.cancelled]: string;
}
